<div (click)="$event.stopPropagation()" *ngIf="userProfile">
    <button type="button" class="avatar d-flex align-items-center justify-content-center position-relative"
        [matMenuTriggerFor]="profileMenu" #menuTrigger="matMenuTrigger"
        [class.menu-open]="menuTrigger.menuOpen"
        (menuOpened)="onMenuOpened()"
        aria-label="Account menu"
        [ngStyle]="{'background-color': avatarColor}">
        <span class="username text-capitalize">{{userProfile.email[0]}}</span>
    </button>

    <mat-menu #profileMenu="matMenu" xPosition="before" class="profile-menu-panel">
        <div class="user-content" (click)="$event.stopPropagation()">
            <div class="user-content-details">
                <div class="user-content-avatar-holder d-flex align-items-center justify-content-center">
                    <div class="user-content-avatar d-flex align-items-center justify-content-center"
                        [ngStyle]="{'background-color': avatarColor}">
                        <span class="username2 text-capitalize">{{userProfile.name[0]}}</span>
                    </div>
                </div>
                <div class="user-details mt-2">
                    <div class="user-display-name">{{name}}</div>
                    <div class="user-email">{{userProfile.email}}</div>
                </div>
                <div class="role-type d-flex flex-row align-items-center justify-content-center mt-2" *ngIf="isAdmin">
                    <span class="type">Admin</span>
                </div>
            </div>
            <div class="user-logout-container d-flex justify-content-center align-items-center">
                <button mat-stroked-button type="button" class="logout-btn overflow-hidden" (click)="logOutUser()">
                    Log Out
                </button>
            </div>
        </div>
    </mat-menu>
</div>
